import { css } from 'styled-components';
import { VariantOfType } from '../../variants';

export const CssRatingDefault = css`
`;

export const ratingVariants = {
  default: CssRatingDefault,
};

export type IRatingVariants = VariantOfType<typeof ratingVariants>;
